<template>
    <v-container class="grey lighten-5" fluid>
        <egertons-cnp v-if="egertons"></egertons-cnp>
        <master-cnp v-else></master-cnp>
    </v-container>
</template>

<script>
import Master from '../components/eterminal/Master.vue';
import MasterCNP from '../components/eterminal/MasterCNP.vue';
// import Egertons from '../components/eterminal/Egertons.vue';
import EgertonsCNP from '../components/eterminal/EgertonsCNP.vue';

export default {
    components: {
        // 'master': Master,
        'master-cnp': MasterCNP,
        // 'egertons': Egertons,
        'egertons-cnp': EgertonsCNP
    },
    beforeMount() {
        this.merchants = this.$store.state.user.merchant_access ? JSON.parse(this.$store.state.user.merchant_access) : null;
    },
    computed: {
        egertons() {
            return this.merchants?.some(el => '8acda4c970585c8501705db797a52314, 8acda4c97597db8a0175ace2421a23a2'.includes(el)) ? this.merchants : null;
        }
    },
    data() {
        return {
            merchants: null
        }
    },
    methods: {
       
    }
}
</script>

<style>


</style>